const INITIAL_STATE = {
  list: [],
  accessList: [],
  controladores: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CAMERA_FETCHED':
      return { ...state, list: action.payload.data || [] };
    case 'CAMERA_ACCESS_FETCHED':
      return { ...state, accessList: action.payload.data || [] };
    case 'CAMERA_CONTROLADORES_FETCHED':
      return { ...state, controladores: action.payload.data || [] };
    case 'CAMERA_PAGE':
      return { ...state, paginaAtual: action.payload };
    default:
      return state;
  }
};
